import { createAction, props } from '@ngrx/store';
import { ConfirmModalConfig, SubmissionsApprovalRequestConfig } from '../../../shared/models/confirmModalConfig';

/* Defining an interface for the EntityConfig object. */
export interface EntityConfig {
  [key: string]: any;
}

/* Creating actions. */
export const loadEntityConfig = createAction(
  '[Entity Config API] Load Entity Config'
);

export const loadEntityConfigSuccess = createAction(
  '[Entity Config API] Entity Config Loaded Success',
  props<{ payload: EntityConfig }>()
);

export const loadEntityConfigError = createAction(
  '[Entity Config API] Entity Config Load Error'
);

export const confirmationModalOpenState =  createAction(
  '[Flow Component] Modal State Change',
  props<{ config: ConfirmModalConfig }>()
);

export const confirmationModalCloseState =  createAction(
  '[Confirmation Component] Modal State Change'
);

/*
action that performs flow deletion as part of a default 2-step approval submission process
 */
export const deployModalAction =  createAction(
  '[Submission Endpoint] Deploy Flow',
  props<{ payload: SubmissionsApprovalRequestConfig }>()
);

/*
 action that performs after deploy has completed. the purpose is to restore the state of the config model to the default
 */
export const completeDeployModalAction =  createAction(
    '[Submission Endpoint] Complete Deploy Flow',
    props<{ completed: boolean }>()
);

/*
 action to be triggered to start the actual deletion by triggering an HTTP request as part of a 1-Click Deploy Process
 */
export const oneClickDeployModalAction =  createAction(
    '[Submission Endpoint] Click to Deploy Flow',
    props<{ payload: SubmissionsApprovalRequestConfig }>()
);

/*
 action to be triggered when user has to confirm flow deletion in dialog as part of a 1-Click Deploy Process
 */
export const oneClickDeployConfirmationModalAction =  createAction(
    '[Submission Endpoint] Click to Deploy Flow Confirmation',
    props<{ payload: SubmissionsApprovalRequestConfig }>()
);

export const confirmErrorAction =  createAction(
  '[Confirmation Component] Error Occured',
  props<{message: string}>()
);

export const loadToastBannerAction = createAction(
  '[Submission Effect] Toast Banner Call',
  props<{ payload }>()
);
